
import {URL_CORE_PRICING_SAVE_CRITERIA_CONTEXT_ID, URL_SAVE_CRITERIA_CONTEXT_ID} from './utils/constants.js';

const URL_HEP = 'api/configuration/hep?type=';

export const URL_SAVE_CRITERIA = 'api/usersearch';

export const URL_DELETE_BULK = 'api/usersearch/bulk';

export const URL_LOAD_TIME = 'api/external/corepricing/loadtime';

export const URL_SAVE_CRITERIA_FILTER_OF_CONTEXT_ID = `?filter=contextId=='${URL_SAVE_CRITERIA_CONTEXT_ID}`;

export const URL_CORE_PRICING_SAVE_CRITERIA_FILTER_OF_CONTEXT_ID = `?filter=contextId=='${URL_CORE_PRICING_SAVE_CRITERIA_CONTEXT_ID}`;

export const URL_SAVE_CRITERIA_FILTER_OF_USER_ID = `;userId==`;

export const URL_RECOMM_SUMMARY_FLATTENED = 'api/external/faresoptimizer/recommendationsummary/search';

export const URL_FARE_CHANGES_SUMMARY_MONGO_FLATTENED = 'api/external/faresoptimizer/farechangessummary/search';

export const URL_FARE_CHANGES_SUMMARY_ATHENA_FLATTENED = 'api/external/faresoptimizer/farechangessummary/athenasearch';

export const URL_HEP_ANALYST_POS_MAPPING = `${URL_HEP}FOAnalystPosMapping`;

export const URL_CORE_PRICING_SEARCH = '/api/external/corepricing/search';
export const URL_DYNAMIC_RESOLUTION = '/api/v1/resolvefares';
